import { aiChatSelectors } from 'app-components/flux/ai-chat';
import { PREFERENCE_V2_NAMES, preferencesV2Selectors, usePreferenceV2 } from 'app-components/flux/preferences-v2';
import { useAppSelector } from 'hooks/redux';
import { useEffect, useRef } from 'react';

import getPendoAPI from 'containers/UserGuide/PendoAPI';

const AI_CHAT_FIRST_OPEN_PENDO_GUIDE_ID = 'n11LJoOWXlTljQq6U2qiquBhh2w';

// chatPanelMounted: the chat panel loads lazily, so the guide waits until the panel is on screen.
export const useAiChatFirstOpenPendoGuide = (chatPanelMounted: boolean): void => {
  const chatUIState = useAppSelector(aiChatSelectors.getChatUIState);
  const preferencesLoaded = useAppSelector((state) => !preferencesV2Selectors.getLoadPending(state));
  const [hasSeenGuide, setHasSeenGuide] = usePreferenceV2(PREFERENCE_V2_NAMES.aiChatFirstOpenGuideSeen, false);
  const previousChatUIStateRef = useRef(chatUIState);
  const pendingOpenRef = useRef(false);

  useEffect(() => {
    const justOpened = previousChatUIStateRef.current !== 'open' && chatUIState === 'open';
    previousChatUIStateRef.current = chatUIState;

    if (chatUIState !== 'open') {
      pendingOpenRef.current = false;
      return;
    }

    if (justOpened) {
      pendingOpenRef.current = true;
    }

    if (!pendingOpenRef.current || !preferencesLoaded || !chatPanelMounted) {
      return;
    }

    pendingOpenRef.current = false;

    if (hasSeenGuide) {
      return;
    }

    const wasShown = getPendoAPI()?.showGuideById?.(AI_CHAT_FIRST_OPEN_PENDO_GUIDE_ID) ?? false;
    if (wasShown) {
      setHasSeenGuide(true);
    }
  }, [chatUIState, chatPanelMounted, hasSeenGuide, preferencesLoaded, setHasSeenGuide]);
};

export { AI_CHAT_FIRST_OPEN_PENDO_GUIDE_ID };
